var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Maintemplate"},[_c('v-app',{staticStyle:{"background":"#EEEEEE"}},[_c('MenuHeader'),_c('v-main',[_c('v-container',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }